import { AspectRatio, MediaType } from "../graphql/generated";

export function getCssAspectRatio(aspectRatio: string) {
  switch (aspectRatio) {
    case "VERTICAL_916":
      return "9:16";
    case "VERTICAL_45":
      return "4:5";
    case "SQUARE":
      return "1:1";
    case "LANDSCAPE_169":
      return "16:9";
    default:
      return aspectRatio;
  }
}

export function formatAspectRatio(aspectRatio: string) {
  switch (aspectRatio) {
    case "VERTICAL_916":
      return "9:16";
    case "VERTICAL_45":
      return "4:5";
    case "SQUARE":
      return "1:1";
    case "LANDSCAPE_169":
      return "16:9";
    default:
      return aspectRatio;
  }
}

export function formatFriendlyMediaName(
  aspectRatio: AspectRatio,
  mediaType: MediaType
): string {
  switch (aspectRatio) {
    case AspectRatio.Vertical_45:
      return `Portrait ${
        mediaType === MediaType.Video ? "Video" : "Image"
      } (4:5)`;
    case AspectRatio.Vertical_916:
      return `Portrait ${
        mediaType === MediaType.Video ? "Video" : "Image"
      } (9:16)`;
    case AspectRatio.Square:
      return `Square ${
        mediaType === MediaType.Video ? "Video" : "Image"
      } (1:1)`;
    case AspectRatio.Landscape_169:
      return `Landscape ${
        mediaType === MediaType.Video ? "Video" : "Image"
      } (16:9)`;
    default:
      return aspectRatio;
  }
}
